export type WorldCup2026GroupId = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'H' | 'I' | 'J' | 'K' | 'L'

export interface WorldCup2026Group {
  id: WorldCup2026GroupId
  teams: readonly [string, string, string, string]
}

export const WORLD_CUP_2026_GROUPS = [
  { id: 'A', teams: ['México', 'Sudáfrica', 'República de Corea', 'Chequia'] },
  { id: 'B', teams: ['Canadá', 'Italia', 'Catar', 'Suiza'] },
  { id: 'C', teams: ['Brasil', 'Haití', 'Marruecos', 'Escocia'] },
  { id: 'D', teams: ['Estados Unidos', 'Paraguay', 'Australia', 'Turquía'] },
  { id: 'E', teams: ['Alemania', 'Curazao', 'Costa de Marfil', 'Ecuador'] },
  { id: 'F', teams: ['Países Bajos', 'Japón', 'Túnez', 'Suecia'] },
  { id: 'G', teams: ['Bélgica', 'Egipto', 'Irán', 'Nueva Zelanda'] },
  { id: 'H', teams: ['España', 'Cabo Verde', 'Arabia Saudí', 'Uruguay'] },
  { id: 'I', teams: ['Francia', 'Senegal', 'Irak', 'Noruega'] },
  { id: 'J', teams: ['Argentina', 'Argelia', 'Austria', 'Jordania'] },
  { id: 'K', teams: ['Portugal', 'Colombia', 'Uzbekistán', 'República Democrática del Congo'] },
  { id: 'L', teams: ['Inglaterra', 'Croacia', 'Ghana', 'Panamá'] },
] as const satisfies readonly WorldCup2026Group[]

export const WORLD_CUP_2026_TEAMS: readonly string[] = WORLD_CUP_2026_GROUPS.flatMap(({ teams }) => teams)

export function getWorldCup2026Group(country: string): WorldCup2026Group | null {
  return WORLD_CUP_2026_GROUPS.find(({ teams }) => teams.some((team) => team === country)) ?? null
}

export function isWorldCup2026Qualified(country: string): boolean {
  return getWorldCup2026Group(country) !== null
}

export function getWorldCup2026GroupRivals(country: string): readonly string[] {
  return getWorldCup2026Group(country)?.teams.filter((team) => team !== country) ?? []
}

export function getWorldCup2026Rivals(country: string): readonly string[] {
  return WORLD_CUP_2026_TEAMS.filter((team) => team !== country)
}

export function getWorldCup2026PhaseTitle(country: string, week: number): string {
  if (week === 0) {
    const group = getWorldCup2026Group(country)
    return `Fase de grupos${group ? ` · Grupo ${group.id}` : ''}`
  }
  return week === 1 ? 'Dieciseisavos de final' : 'Octavos de final'
}

/** Títulos de las jornadas de ruta tras insertar el descanso del Mundial. */
export function getWorldCup2026RoutePhaseTitle(country: string, week: number): string {
  if (week === 0) return getWorldCup2026PhaseTitle(country, 0)
  return week === 2 ? 'Dieciseisavos de final' : 'Octavos de final'
}
